import "primeicons/primeicons.css";
import "primereact/resources/themes/lara-light-indigo/theme.css";
import "primereact/resources/primereact.css";
import "assets/scss/dashboard.scss";
import "assets/css/charts_form_controls.css";
import "assets/css/grid_table.css";
import numeral from "numeral";
import React, { useState, useRef, useLayoutEffect, useEffect } from "react";
import { classNames } from "primereact/utils";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Toast } from "primereact/toast";
import { Button } from "primereact/button";
import { InputNumber } from "primereact/inputnumber";
import { Dialog } from "primereact/dialog";
import { InputText } from "primereact/inputtext";
import { Card } from "primereact/card";
import Select from "react-select";
import { Divider } from "primereact/divider";
import moment from "moment";
import { getDataApi, saveApi,postDataApi, loadApi } from "services/appApi";
import { pecaPageRows, pecaRowsPerPageOptions } from "pages/common/envPECA";
import axios from "axios";

const DefectTypeCodes = () => {
  let emptyRow = {
    user_id: null,
    defect_type_id:null,
    defect_type:"",
    defect_code_id:null,
		defect_code:"",
		defect_description:"",	
		defect_condition_type:"",		
		sort_key:"",			
		comments_required_flag:"",
		comments_required_flag_disp:"",
		start_date_active:"",
		end_date_active:""
    };

  const [rows, setRows] = useState([]);
  const [rowDialog, setRowDialog] = useState(false);
  const [row, setRow] = useState(emptyRow);
  const [selectedRows, setSelectedRows] = useState(null);
  const [deleteRowDialog, setDeleteRowDialog] = useState(false);
  const [showproductDialog, setShowProductDialog] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [globalFilter, setGlobalFilter] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [errorDialogVisible, setErrorDialogVisible] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [dialog, setDialog] = useState("");
  const [wasDataFetchingSuccessful, setWasDataFetchingSuccessful] = useState(true);
    const [fetchDefectType, setFetchDefectType] = useState(true);
    const [fetchDefectConditionType, setFetchdefectConditiontype] = useState(true);
    const [fetchCommentsRequiredLov, setFetchCommentsRequiredLov] = useState(true);
    
    
  
    const [defectType, setdefectType] = useState([]);
    const [defectConditiontype, setdefectConditiontype] = useState([]);
    const [commentsRequired, setCommentsRequired] = useState([]);
      
    const [defectTypeId, setdefectTypeId] = useState({label: "", value: null});
    const [defectTypeCode, setDefectTypeCode]=useState("");
    const [defectDescription, setDefectDescription]=useState("");
    const [defectConditionTypeId, setdefectConditionTypeId] = useState({label: "", value: null});  
    const [startDate, setStartDate] = useState();
    const [endDate, setEndDate] = useState();  
    const [commentsRequiredId, setCommentsRequiredId] = useState({label: "", value: ""});    
    const [sortKey, setSortKey] = useState(null);
  
    const [defectTypeSelectId, setDefectTypeSelectId] = useState({label: "", value: null});
    const [defectConditiontypeSelectId, setDefectConditiontypeSelectId] = useState({label: "", value: null});   
    const [commentsRequiredSelectFlagId, setCommentsRequiredSelectFlagId] = useState({label: "", value: ""});
    

  const toast = useRef(null);
  const dt = useRef(null);

  useEffect(() => {
                const fetchDefectType = async () => {
                  setFetchDefectType(true);
                  try {
                    let res = await postDataApi("/api/setup/defects/defectTypeCodes/defectTypeLov");
                    if (res) {
                      let successFlag = res.data[0];
                      console.log("Response1: ",res);
                      console.log("Success Flag",successFlag);
                      if (successFlag === "Y" && Array.isArray(res.data[1])) {
                        const options= res.data[1].map((item)=>({
                          label:item. defect_type,
                          value:item.defect_type_id
                        }))
                        setdefectType(options)
                        setFetchDefectType(false);
                      } 
                    }
                  } catch (err) {
                    console.log(err);
                    setFetchDefectType(false);
                  }
                };
                fetchDefectType();
              }, []);
  
      useEffect(() => {
                  const fetchDefectConditionType = async () => {
                    setFetchdefectConditiontype(true);
                    try {
                      let res = await postDataApi("/api/setup/defects/defectTypeCodes/defectConditionTypeLov");
                      if (res) {
                        let successFlag = res.data[0];
                        console.log("Response2: ",res);
                        console.log("Success Flag",successFlag);
                        if (successFlag === "Y" && Array.isArray(res.data[1])) {
                          const options= res.data[1].map((item)=>({
                            label: item.meaning,
                            value: item.lookup_code
                          }))
                          setdefectConditiontype(options)
                          setFetchdefectConditiontype(false);
                        } 
                      }
                    } catch (err) {
                      console.log(err);
                      setFetchdefectConditiontype(false);
                    }
                  };
                  fetchDefectConditionType();
                }, []);

      useEffect(() => {
                        
                  const fetchCommentsRequiredLov = async () => {
                    setFetchCommentsRequiredLov(true);
                    try {
                      let res = await postDataApi("/api/setup/defects/defectTypeCodes/commentsLov");
                      if (res) {
                        let successFlag = res.data[0];
                        console.log("Response3: ",res);
                        console.log("Success Flag",successFlag);
                        if (successFlag === "Y" && Array.isArray(res.data[1])) {
                          const options= res.data[1].map((item)=>({
                            label: item.meaning,
                            value: item.lookup_code
                          }))
                          setCommentsRequired(options);
                          setFetchCommentsRequiredLov(false);
                        } 
                      }
                    } catch (err) {
                      console.log(err);
                      setFetchCommentsRequiredLov(false);
                    }
                  };
                  fetchCommentsRequiredLov();
                }, []);
      
          
  // Fetch Processes when the component mounts
  const handleLoadData = async () => {

    const p_param = {
    p_defect_type_id:defectTypeId.value,
    p_defect_code:defectTypeCode,       
    p_defect_description:defectDescription,
    p_sort_key:sortKey,
    p_defect_condition_type:defectConditionTypeId.label,  
    p_start_date_active:startDate,
    p_end_date_active:endDate,
    p_comments_required_flag:commentsRequiredId.value,

    };
    console.log(p_param);
      try {
              setIsLoading(true);
              const response = await loadApi(p_param,"/api/setup/defects/defectTypeCodes/selRows");
              console.log(response);
              console.log("Fetched Defect Codes:", response.data);
              console.log(response.data[0]);
              console.log(response.data[1]);
              if (response.data.length > 0) {
                let successFlag = response.data[0];
                if (successFlag === "Y") {
                  toast.current.show({
                    severity: 'success',
                    summary: 'Success',
                    detail: 'Data fetched successfully'
                  })
                  console.log("success=Y");
                  setRows(response.data[1]);
                  setIsLoading(false);
                  setWasDataFetchingSuccessful(false);
                } else {
                  //setRows(null);
                  setRows([]);
                  setIsLoading(false);
                  const errorInfo = response.data[2];
      
                  // Set the error message and display the dialog
                  setErrorMessage(errorInfo);
                  setErrorDialogVisible(true);
                  setWasDataFetchingSuccessful(true);
                }
                //setSearch(response.data);
              } else {
                //setRows(null);
                setRows([]);
                setIsLoading(false);
                setWasDataFetchingSuccessful(true);
              }
      
              //setRows(response.data);
            } catch (error) {
              if(axios.isCancel(error) ||  error.name== 'CanceledError') {
              console.log("Request was cancelled by the user.");
      
              toast.current.show({
                severity: 'warn',
                summary: 'Cancelled',
                detail: 'Request successfully cancelled by the user.',
                life: 3000,
              })
              setIsLoading(false);
            } else {
              console.error("Error fetching Defect Codes:", error);
            }
            } finally {
            setIsLoading(false);
          }
          };

  const showProduct = (row) => {
    setRow({ ...row });
    setShowProductDialog(true);
  };
  const openNew = () => {
    setRow(emptyRow);
    setDefectTypeSelectId({label: "", value: null});
    setDefectConditiontypeSelectId({label: "", value: null});
    setCommentsRequiredSelectFlagId({label: "", value: null}); 
    setSubmitted(false);
    setRowDialog(true);
    setDialog("create")
  };

  const hideDialog = () => {
    setSubmitted(false);
    setRowDialog(false);
    setDialog("")
    setShowProductDialog(false);
    setErrorDialogVisible(false);
  };

  const formatDateColumn = (dateValue) => {
    return dateValue ? moment.utc(dateValue).format("DD-MMM-YYYY") : null;
  };

  const startDateBodyTemplate = (rowData) => {
    return formatDateColumn(rowData.start_date_active);
  };

  const endDateBodyTemplate = (rowData) => {
    return formatDateColumn(rowData.end_date_active);
  };

 

  const saveRow = async () => {
    setSubmitted(true);
      //      const isNew = !row.process_id;
      //     const formattedRow = formatDateFields(row, isNew);

      let _rows = [...rows];
      let _row = { ...row };

      try {
        if (row.defect_code_id) {
          /*** Update Row */
          const response = await saveApi(row, "/api/setup/defects/defectTypeCodes/updRow");
          //await axios.put(`http://localhost:5000/api/machines/${row.row_id}`, formattedRow);
          //             const updatedRows = rows.map((p) => (p.row_id === row.row_id ? formattedRow : p));
          //             setRows(updatedRows);
          console.log("updating");
          console.log(response.data);
          let successFlag = response.data[0];
          if (successFlag === "Y") {
            const index = findIndexById(row.defect_code_id);
            _rows[index] = _row;
            toast.current.show({
              severity: "success",
              summary: "Successful",
              detail: "Defect code Updated",
              life: 3000,
              width: "600px",
            });
          } else {
            let err_msg = response.data[1];
            toast.current.show({
              severity: "error",
              summary: err_msg,
              detail: "Defect code Not Updated",
              life: 3000,
              width: "600px",
            });
          }
        } else {
          /*** Insert Row */
          const response = await saveApi(row, "/api/setup/defects/defectTypeCodes/insRow");
          //const response = await axios.post('http://localhost:5000/api/machines', formattedRow);
          //       formattedRow.row_id = response.data.id;
          //     setRows([...rows, formattedRow]);
          console.log("saving");
          console.log("Response data: ", response.data);
          console.log("Response: ", response);
          let successFlag =
            response.data[0]; /** This contains value of Y or N */
          if (successFlag === "Y") {
            _row.defect_code_id =
              response.data[1]; /** It contains newly created Id */
            _rows.push(_row);
            toast.current.show({
              severity: "success",
              summary: (
                <div style={{ marginright: "200px", width: "600px" }}>
                  Success
                </div>
              ),
              detail: <div style={{ width: "600px" }}>Defect Type Code Created</div>,
              life: 3000,
              width: "600px",
            });
          } else {
            let err_msg = response.data[2];
            toast.current.show({
              severity: "error",
              summary: <div style={{ width: "600px" }}>{err_msg}</div>,
              detail: <div style={{ width: "600px" }}>{err_msg}</div>,
              life: 3000,
              width: "600px",
            });
          }
        }

        setRows(_rows);
        setRowDialog(false);
        setRow(emptyRow);
      } catch (error) {
        console.error("Error saving defect code:", error);
        toast.current.show({
          severity: "error",
          summary: "Error",
          detail: "Defect Code Save Failed",
          life: 3000,
          width: "600px",
        });
      }
  };

  const editRow = (row) => {
    setRow({ ...row });
    setDefectTypeSelectId({label: row.defect_type, value: row.defect_type_id});
    setDefectConditiontypeSelectId({label: row.defect_condition_type});
    setCommentsRequiredSelectFlagId({label: row.comments_required_flag_disp, value: row.comments_required_flag});
    setRowDialog(true);
    setDialog("edit")
  };

  const findIndexById = (id) => {
    let index = -1;
    for (let i = 0; i < rows.length; i++) {
      if (rows[i].defect_code_id === id) {
        index = i;
        break;
      }
    }
    return index;
  };

  const exportCSV = () => {
    dt.current.exportCSV();
  };

  const hideDeleteRowDialog = () => {
    setDeleteRowDialog(false);
  };

   const confirmDeleteRow = (row) => {
      setRow(row);
      setDeleteRowDialog(true);
    };
   
     
          

  const getLoadingHeaderContents = () => {
    return (
      <React.Fragment>
        <div className="row d-flex justify-content-center m-5">
          <div className="col-auto">
            <div className="card shadow-sm border-primary">
              <div className="card-header bg-primary text-white">
                <h2 className="mb-0">Inquire-Defect Type Code</h2>
              </div>
              <div className="card-body text-center">
                <h3>
                  <i className="fa-duotone fa-fw fa-spin-pulse fa-loader me-3"></i>{" "}
                  The page is loading...
                </h3>
              </div>
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  };

  const getLoadedHeaderContents = () => {
                  return (
                    <React.Fragment>
                      <div className="header-container">
                        <h2 className="text-center my-3 d-flex flex-column flex-md-row align-items-center justify-content-center">
                        Inquire-Defect Type Code
                        </h2>
                        <h2 className="text-center my-3 d-flex flex-column flex-md-row align-items-center justify-content-center">
                          <div className="header-container p-1">
                              <style>
                              {`
                                input::placeholder {
                                  font-size: 17px; 
                                }
                              `}
                            </style>
                          {/* <span className="p-input-icon-right w-full md:w-auto"> 
                        <InputText
                          type="search"
                          onInput={(e) => setGlobalFilter(e.target.value)}
                          placeholder="Search..."
                          className="w-full lg:w-auto text-sm p-3"
                          style={{ fontSize: '17px' }} 
                        />
                      </span> */}
                          </div>
                        </h2>
                      </div>
                    </React.Fragment>
                  );
                }


  const onInputChange = (e, name) => {
    const val = (e.target && e.target.value) || "";
    let _row = { ...row };
    _row[`${name}`] = val;

    setRow(_row);
  };

 
  const onInputDefectTypeSelectIdChange = (selectedOption, name, id) => {
    if(selectedOption == null) {
      setDefectTypeSelectId({label: "", value: null});
    } else {
    setDefectTypeSelectId(selectedOption);
    }
    const val = selectedOption != null ? selectedOption.value : null;
    const val1 = selectedOption != null ? selectedOption.label : "";

    let _row = { ...row };
    _row[`${id}`] = val;
    _row[`${name}`] = val1;

    setRow(_row);
    
  };


  const onInputDefectConditionTypeSelectChange = (selectedOption, name, id) => {
    if(selectedOption == null) {
      setDefectConditiontypeSelectId({label: "", value: null});
    } else {
    setDefectConditiontypeSelectId(selectedOption);
    }
    const val = selectedOption != null ? selectedOption.value : null;
    const val1 = selectedOption != null ? selectedOption.label : "";

    let _row = { ...row };
    _row[`${id}`] = val;
    _row[`${name}`] = val1;

    setRow(_row);
    console.log(row);

  };
  const onInputCommentsRequireIdChange = (selectedOption, name, id) => {
    if(selectedOption == null) {
      setCommentsRequiredSelectFlagId({label: "", value: ""});
    } else {
    setCommentsRequiredSelectFlagId(selectedOption);
    }
    const val = selectedOption != null ? selectedOption.value : "";
    const val1 = selectedOption != null ? selectedOption.label : "";
    console.log("responseB4",row)

    let _row = { ...row };
    _row[`${id}`] = val;
    _row[`${name}`] = val1;

    setRow(_row);
    console.log("response4",row)
  };



  const onInputNumberChange = (e, name) => {
    const val = (e.target.valueAsNumber) || "";
    let _row = { ...row };
    _row[`${name}`] = val;

    setRow(_row);
  };

  /***
    const leftToolbarTemplate = () => {
        return (
            <React.Fragment>
                <Button label="New" icon="pi pi-plus" className="p-button-success p-mr-2" onClick={openNew} />
            </React.Fragment>
        )
    }

    const headerDontUse = (
        <div className="table-header">
            <h5 className="p-m-0">Manage Machines</h5>
            {/* <span className="p-input-icon-left">
                <i className="pi pi-search" />
                <InputText type="search" onInput={(e) => setGlobalFilter(e.target.value)} placeholder="Search..." />
            </span> * /}
        </div>
    );
    */

  const header = (
    <div
      className="table-header"
      style={{
        display: "flex",
        justifyContent: "space-between",
        height: "3rem",
        alignContent: "center",
      }}
    >
      <div
        style={{
          width: window.innerWidth / 3,
          display: "flex",
          justifyContent: "flex-start",
          marginRight: "110px",
        }}
      >
        <span className="p-input-icon-right w-full md:w-auto">
        <InputText
          type="search"
          onInput={(e) => setGlobalFilter(e.target.value)}
          placeholder="Search..."
          className="w-full lg:w-auto"
        />
      </span>
      </div>
      <div>
        <Button
          // label="New"
          icon="pi pi-plus"
          className="p-button-rounded p-button-success p-mr-2"
          onClick={openNew}
          tooltip="New"
          tooltipOptions={{ position: "bottom" }}
        />
        <Button
          icon="pi pi-upload"
          className="p-button-primary p-button-rounded"
          onClick={exportCSV}
          tooltip="Export"
          tooltipOptions={{ position: "bottom" }}
          style={{ marginLeft: "20px" }}
        />
      </div>
    </div>
  );

  const actionBodyEditTemplate = (rowData) => {
    return (
      <React.Fragment>
        <Button
          icon="pi pi-pencil"
          className="p-button-rounded p-button-success p-mr-2"
          onClick={() => editRow(rowData)}
          tooltip="Edit"
          tooltipOptions={{ position: "bottom" }}
          // disabled={true}
        />
      </React.Fragment>
    );
  };

  const sDate = row.start_date_active ? moment.utc(row.start_date_active).format("DD-MMM-YYYY") : null;
  const eDate = row.end_date_active ? moment.utc(row.end_date_active).format("DD-MMM-YYYY") : null;

  const readBodyTemplate = (rowData) => {
    return (
      <React.Fragment>
        <Button
          icon="pi pi-eye"
          className="p-button-rounded p-button-primary"
          onClick={() => showProduct(rowData)}
          tooltip="View"
          tooltipOptions={{ position: "bottom" }}
        />
      </React.Fragment>
    );
  };

     const CardComponent = ({title, data}) => {
      const rightAlignedLabels = ["Sort Key : "];
    
          return (
            <Card className="card-containers">
              <h5  style={{"fontWeight":"bold"}}> {title} </h5>
              <Divider className="my-2" />
              {data.map((item, index) => (
                <div key={index} className="label-value-pair">
                  <span className="label">{item.label}</span>
                  
                  {item.label &&
                  <span         
                  className={`value-box ${rightAlignedLabels.includes(item.label) ? "align-right": ""}`}>
                    {item.value}</span>
                  }
                  
                </div>
              ))}
            </Card>
          )
        }
  
  const inputRightBoxStyle = {
    textAlign: "right",
     outline: "0.015625rem thin #d3d3d3",
    borderradius: "5px", 
    border: "thin solid #d3d3d3",
    paddingLeft: "6px",
    borderRadius: "4px",
    backgroundColor:"rgb(235, 235, 235)",
    width: "100%",
  }
  const inputDateStyle = {
    outline: "0.015625rem thin #d3d3d3",
    borderradius: "5px", 
    border: "thin solid #d3d3d3",
    paddingLeft: "6px",
    borderRadius: "4px",
    backgroundColor:"rgb(235, 235, 235)",
    width: "100%",
  }
  const formatDateTime = (dateString) => {
    if (!dateString) return "";
    const date = new Date(dateString);
    const year = date.getUTCFullYear();
    const month = String(date.getUTCMonth() + 1).padStart(2, "0");
    const day = String(date.getUTCDate()).padStart(2, "0");
    return `${year}-${month}-${day}`
  }

  
  const handledefectTypeId = (selectedOption) => {
    if(selectedOption == null) {
      setdefectTypeId({label: "", value: null});
    } else {
    setdefectTypeId(selectedOption);
    }
  }

  const handledefectConditionTypeId = (selectedOption) => {
    if(selectedOption == null) {
      setdefectConditionTypeId({label: "", value: null});
    } else {
    setdefectConditionTypeId(selectedOption);
    }
  }
  const handleCommentsRequiredflagId = (selectedOption) => {
    if(selectedOption == null) {
      setCommentsRequiredId({label: "", value: ""});
    } else {
    setCommentsRequiredId(selectedOption);
    console.log(commentsRequiredId)
    }
  }

  
     const getDefectTypeControl = () => (
              <React.Fragment>
            <div className="col-auto form-group ps-2 pe-0 d-flex flex-column">
              <label className="form-label">Defect type</label>
               <Select
                  id="defectTypeId"
                  name="defectTypename"
                  onChange={handledefectTypeId}
                  options={defectType}
                  value={defectTypeId}
                  placeholder="Select Defect Type"
                  isSearchable={true}
                  isClearable={true}
                  isDisabled={isLoading}
                  className="select-dropdown"
                  classNamePrefix="select-dropdown"
                />
            </div>
          </React.Fragment>
            );
    
    
   
    const getdefectConditionTypeName = () => (
          <React.Fragment>
        <div className="col-auto form-group ps-2 pe-0 d-flex flex-column">
          <label className="form-label">Defect Condition Type</label>
           <Select
              // className="form-select"
              id="defectConditionTypeId"
              name="defectConditiontype"
              onChange={handledefectConditionTypeId}
              options={defectConditiontype}
              value={defectConditionTypeId}
              placeholder="Select Machine"
              isSearchable={true}
              isClearable={true}
              isDisabled={isLoading}
              className="select-dropdown"
              classNamePrefix="select-dropdown"
            />
        </div>
      </React.Fragment>
        );
        const getDefectTypeCodeControl = () => (
            <React.Fragment>
              <div className="col-auto form-group ps-2 pe-0 d-flex flex-column">
              <label className="form-label">Defect Type Code</label>
                    <InputText 
                    type="text"
                    id = "defectTypecode"
                    name="defectTypecode" 
                    onChange={(e) => setDefectTypeCode(e.target.value)}
                    placeholder="Enter Defect Type Code"
                    disabled={isLoading}
                    className="input-outline" />
                     </div>
            </React.Fragment>
          );
        
          const getDefectDescriptionControl = () => (
            <React.Fragment>
              <div className="col-auto form-group ps-2 pe-0 d-flex flex-column">
              <label className="form-label">Defect Description</label>
                    <InputText 
                    type="text"
                    id = "defectdescription"
                    name="defectdescription" 
                    onChange={(e) => setDefectDescription(e.target.value)}
                    placeholder="Enter Defect Description"
                    disabled={isLoading}
                    className="input-outline" />
                     </div>
            </React.Fragment>
          );


      const getSortKeyControl = () => (
        <React.Fragment>
          <div className="col-auto form-group ps-2 pe-0 d-flex flex-column">
            <label className="form-label">Sort Key</label>
           <input
           type="number"
           value={sortKey}
           onChange={(e) => setSortKey(e.target.valueAsNumber)}
           className="input-outline"
           />
          </div>
        </React.Fragment>
      );

       const getCommentsRequired = () => (
              <React.Fragment>
                <div className="col-auto form-group ps-2 pe-0 d-flex flex-column">
                  <label className="form-label">Comments Required?</label>
                 <Select
                  // className="form-select"
                  id="commentsRequiredId"
                  name="commentsRequiredId"
                  onChange={handleCommentsRequiredflagId}
                  
                  options={commentsRequired}
                  placeholder="Comments Required"
                  isSearchable={true}
                  isClearable={true}
                  isDisabled={isLoading}
                  className="select-dropdown1"
                  classNamePrefix="select-dropdown1"
                />
                </div>
              </React.Fragment>
            );
      
      

      const getStartEndDateControls = () => (
          <React.Fragment>
            <div className="col-auto form-group ps-2 pe-0 d-flex flex-column">
              <label className="form-label">Start Date Active</label>
              <div className="input-group date input-wrapper">
              <input
                type="date"
                id="StartDate"
                name="StartDate"
                value={startDate}
                onChange={handleStartDateChange}
                disabled={isLoading}
                className="input-outline1"
              />
              </div>
            </div>
            <div className="col-auto form-group ps-2 pe-0 d-flex flex-column">
              <label className="form-label">End Date Active</label>
              <div className="input-group date input-wrapper">
              <input
                type="date"
                id="EndDate"
                name="EndDate"
                value={endDate}
                onChange={handleEndDateChange}
                disabled={isLoading}
                className="input-outline1"
              />
              </div>
            </div>
          </React.Fragment>
        );
      
        const handleStartDateChange = (e) => {
          setStartDate(e.target.value);
        };
      
        const handleEndDateChange = (e) => {
          setEndDate(e.target.value);
        };

     const getGoButtonControl = () => (
        <React.Fragment>
          <div className="col-auto d-flex align-items-center justify-content-center ps-2 pe-0" style={{paddingTop:'1.9375rem'}}>
            <button
              type="button"
              className="btn btn-primary load-button"
              id={"chartAreaId"}
              onClick={handleLoadData}
              disabled={isLoading}
            >
               <i
                className={
                  isLoading ? "fa-duotone fa-fw fa-rotate fa-spin" : "fa-duotone fa-fw fa-rotate"
                }
              ></i>
              <span>{isLoading ? "Loading" : "Go"}</span>
            </button>
          </div>
        </React.Fragment>
      );

      const inputBoxStyle = {
    backgroundColor:"rgb(235, 235, 235)",
    padding: "6px 10px",
    borderRadius: "4px",
    display: "block",
    wordWrap: "break-word",
    overflowWrap: "break-word",
    flexGrow: 1,
    minWidth: 0,
  }
  return (
    <div>
      <Toast ref={toast} />
    <div className="col mx-2">
        {fetchDefectType && fetchDefectConditionType  ? getLoadingHeaderContents() : getLoadedHeaderContents()}
        {!fetchDefectType && !fetchDefectConditionType  && (
        <div className="row">
          <div className="col">
            <div className="row justify-content-center">
              {getDefectTypeControl()}
              {getDefectTypeCodeControl()}
              {getDefectDescriptionControl()}
              {getdefectConditionTypeName()}
              {getStartEndDateControls()}
              {getSortKeyControl()}
              {getCommentsRequired()}
              {getGoButtonControl()}
             
            </div>
            {!wasDataFetchingSuccessful && (
              <div className="card my-3">
            {/* <div className="text-3xl text-800 font-bold mb-4">Inquire NonWork Type</div> */}
            <DataTable
              ref={dt}
              value={rows}
              selection={selectedRows}
              onSelectionChange={(e) => setSelectedRows(e.value)}
              dataKey="defect_code_id"
              scrollable
              scrollHeight="flex"
              className="custom-datatable-border"
              tableStyle={{ minWidth: "50rem" }}
              paginator
              rows={pecaPageRows}
              rowsPerPageOptions={pecaRowsPerPageOptions}
              paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
              currentPageReportTemplate="Showing {first} to {last} of {totalRecords} Machine"
              globalFilter={globalFilter}
              header={header}
              emptyMessage="No Defect Code  found"
              stripedRows
              showGridlines        
              responsiveLayout="scroll"
              rowExpansion
            >
             
                                        <Column
                                          body={readBodyTemplate}
                                          exportable={false}
                                          style={{ width: "0.75rem" }}
                                        ></Column>
                                        <Column
                                          //field="shift_type_id"
                                          field="defect_code_id"
                                          header="id"
                                          sortable="false"
                                          hidden="true"
                                          exportable={false}
                                          style={{ whiteSpace: "nowrap" }}
                                        ></Column>
                                        <Column
                                          field="defect_type"
                                          header="Defect Type"
                                          sortable
                                          style={{ whiteSpace: "nowrap" }}
                                        ></Column>
                                        <Column
                                          field="defect_code"
                                          header="Defect Type Code"
                                          sortable
                                          style={{ whiteSpace: "nowrap" }}
                                        ></Column>
                                        <Column
                                          field="defect_description"
                                          header="Defect Description"
                                          sortable
                                          style={{ whiteSpace: "nowrap" }}
                                        ></Column>
                                        <Column
                                          field="start_date_active"
                                          header="Active Start Date"
                                          body={startDateBodyTemplate}
                                          sortable
                                          style={{ whiteSpace: "nowrap" }}
                                        ></Column>
                                        <Column
                                          field="end_date_active"
                                          header="Active End Date"
                                          body={endDateBodyTemplate}
                                          sortable
                                          style={{ whiteSpace: "nowrap" }}
                                        ></Column>
                                        <Column
                                          field="defect_condition_type"
                                          header="Defect Condition Type"
                                          sortable
                                          style={{ whiteSpace: "nowrap" }}
                                        ></Column>
                                        <Column
                                          field="sort_key"
                                          header="Sort Key"
                                          sortable
                                          style={{ whiteSpace: "nowrap" }}
                                        ></Column>
                                        <Column
                                          field="comments_required_flag_disp"
                                          header="Comments Required"
                                          sortable
                                          style={{ whiteSpace: "nowrap" }}
                                        ></Column>
                                                  
                                        <Column
                                          body={actionBodyEditTemplate}
                                          style={{ width: "0.75rem" }}
                                        ></Column>
              
            </DataTable>
          </div>
        )}
        </div>
        </div>
        )}
        <Dialog
          visible={rowDialog}
          style={{ width: "1400px" }}
          modal
          className="p-fluid"
          onHide={hideDialog}
        >
          <h4 style={{"fontWeight":"bold"}}> Defect Type Codes Details  </h4>
          <Divider className="my-4" />
          <h5 style={{"fontWeight":"bold"}}>  {dialog === "edit" ? "Update Defect Type Code" : dialog === "create" ? "Create Defect Type Code" : ""} </h5>
          <Divider className="my-4" />
          <div className="card-wrapper">
          <Card className="card-containers">
            <h5  style={{"fontWeight":"bold"}}> Defect Type Code Details  </h5>
            <Divider className="my-2" />


<div className="label-value-pair">
            <span className="label" htmlFor="defect_type_id">Defect Type  </span>
            <span style={{flexGrow:1}}>
            <Select
            // className="form-select"
            id="defectTypeSelectId"
            name="defectTypeSelectId"
            onChange={(selectedOption) => onInputDefectTypeSelectIdChange(selectedOption, "defect_type", "defect_type_id")}
            options={defectType}
            value={defectTypeSelectId}
            placeholder="Select Defect Type"
            isSearchable={true}
            isClearable={true}
            isDisabled={isLoading}
            lassName="select-dropdown2"
            classNamePrefix="select-dropdown2"
          />
            </span>
            {submitted && row.defect_type_id == null && dialog === "create" && (
              <small className="p-error">Defect Type is required.</small>
            )}
          </div>


          <div className="label-value-pair">
                                            <span className="label" htmlFor="defect_type_code">Defect Type Code : </span>
                                            <span style={{flexGrow:1}}>
                                              <InputText
                                            // className="form-select"
                                            id="defectTypeCodeSelectId"
                                            name="defectTypeCodeSelectId"
                                            value={row.defect_code}
                                            onChange={(e) => onInputChange(e, "defect_code")}
                                            placeholder="Enter Defect Type code"
                                            style={inputBoxStyle}
                                            />
                                            {submitted && row.defect_code == "" && (
                                                          <small className="p-error">Defect Type  codeis required.</small>
                                                        )}
                                            </span>
                                            
                                          </div>
                                        
                      <div className="label-value-pair">
                                             <span className="label" htmlFor="defect_description">Defect Description : </span>
                                             <span style={{flexGrow:1}}>
                                               <InputText
                                             // className="form-select"
                                             id="defectdescriptionEdit"
                                             name="defectdescriptionEdit"
                                             value={row.defect_description}
                                             onChange={(e) => onInputChange(e, "defect_description")}
                                             placeholder="Enter Defect Description"
                                             style={inputBoxStyle}
                                             />
                                             {/* {submitted && row.defect_description == "" && (
                                                           <small className="p-error">Defect Description is required.</small>
                                                         )} */}
                                             </span>
                                             
                                           </div>

            <div className="label-value-pair">
            <span className="label" htmlFor="defect_condition_type">Defect Condition Type : </span>
            <span style={{flexGrow:1}}>
              <Select
            // className="form-select"
            id="defectConditiontypeSelectId"
            name="defectConditiontypeSelectId"
            onChange={(selectedOption) => onInputDefectConditionTypeSelectChange(selectedOption, "defect_condition_type", "defect_condition_type")}
            options={defectConditiontype}
            value={defectConditiontypeSelectId}
            placeholder="Select Defect Condition Type"
            isSearchable={true}
            isClearable={true}
            isDisabled={isLoading}
            lassName="select-dropdown2"
            classNamePrefix="select-dropdown2"
          />
            </span>
            
          </div>
<div className="label-value-pair">
            <span className="label" htmlFor="comments_required_flag">Comments Required? : </span>
            <span style={{flexGrow:1}}>
            <Select
            // className="form-select"
            id="commentsRequiredSelectFlagId"
            name="commentsRequiredSelectFlagId"
            onChange={(selectedOption) => onInputCommentsRequireIdChange(selectedOption, "comments_required_flag_disp", "comments_required_flag")}
            options={commentsRequired}
            value={commentsRequiredSelectFlagId}
            placeholder="SSelect Comments"
            isSearchable={true}
            isClearable={true}
            isDisabled={isLoading}
            lassName="select-dropdown2"
            classNamePrefix="select-dropdown2"
          />
            </span>
            
          </div>



          <div className="label-value-pair">
            <span className="label"htmlFor="sort_key">Sort Key : </span>
            <span style={{flexGrow:1}}>
           <input
           type="number"
           value={row.sort_key}
           onChange={(e) => onInputNumberChange(e, "sort_key")}
           style={inputRightBoxStyle}
           />
            </span>
          </div>
          </Card>
          <Card className="card-containers">
            <h5  style={{"fontWeight":"bold"}}> Active Dates </h5>
            <Divider className="my-2" />
            <div className="label-value-pair">
            <span className="label" htmlFor="start_date_active">Active Start Date : </span>
            <span style={{flexGrow:1}} className="input-wrapper">
            <input
              type="date"
              id="start_date_active"
              defaultValue={formatDateTime(row.start_date_active)}
              onChange={(e) => onInputChange(e, "start_date_active")}
              style={inputDateStyle}
            />
            </span>
          </div>
          <div className="label-value-pair">
            <span className="label" htmlFor="end_date_active">Active End Date : </span>
            <span style={{flexGrow:1}} className="input-wrapper">
            <input
              type="date"
              id="end_date_active"
              defaultValue={formatDateTime(row.end_date_active)}
              onChange={(e) => onInputChange(e, "end_date_active")}
              style={inputDateStyle}
            />
            </span>
          </div>
          </Card>
          </div>
          <div className="btn-container">
          <Button
            label="Cancel"
            icon="pi pi-times"
            className="p-button-text"
            onClick={hideDialog}
            style={{"width":"20%","backgroundColor":"#0d6efd", "color":"white", "borderRadius":"4px", "cursor":"pointer"}}
          />
          <Button
            label="Save"
            icon="pi pi-check"
            className="p-button-text"
            onClick={saveRow}
            style={{"width":"20%","backgroundColor":"#0d6efd", "color":"white", "borderRadius":"4px", "cursor":"pointer"}}
          />
          </div>
        </Dialog>



        <Dialog visible={showproductDialog} style={{ width: '1400px' }} modal className="p-fluid" onHide={hideDialog}>     
                                <h4 style={{"fontWeight":"bold"}}>  Defect Type Code Details </h4>
                                <Divider className="my-4" />
                                <h5 style={{"fontWeight":"bold"}}> View Defect Type Code </h5>
                                <Divider className="my-4" />
                                <div className="card-wrapper">
                                  <CardComponent
                                    title="Defect Type Code Details  "
                                    data={[{label:"Defect Type : ", value: row.defect_type },
                                      {label:"Defect Type Code : ", value: row.defect_code },
                                      {label:"Defect Description : ", value: row.defect_description},
                                      {label:"Defect Condtion Type : ", value: row.defect_condition_type},
                                      {label:"Sort Key : ", value: row.sort_key},
                                      {label:"Comments Required : ", value: row.comments_required_flag}
                                    ]}
                                  />
                                  <CardComponent
                                    title="Active Dates"
                                    data={[
                                      {label:"Active Start Date : ", value: sDate },
                                      {label:"Active End Date : ", value: eDate },
                                    ]}
                                  />
                                 </div>
                            </Dialog>
          
                    <Dialog 
                        header="API Error" 
                        visible={errorDialogVisible} 
                        style={{ width: '400px' }} 
                        onHide={hideDialog} 
                        footer={
                            <Button label="OK" onClick={hideDialog} className="p-button-primary p-button-rounded" />
                        }
                    >    
                     <p>
        
                            {errorMessage}
                        </p>
                    </Dialog>
                    <style jsx>{`
                      .card-wrapper {
                        display: grid;
                        grid-template-columns: repeat(2,1fr);
                        gap: 10px;
                        padding: 5px;
                      }
        
                      .card-containers {
                        display: flex;
                        background-color: #f9f9f9;
                        flex-direction: column;
                        justify-content: flex-start;
                        border: 1px solid #ccc;
                        paddig: 10px;
                        box-shadow: 4px 4px 10px rgba(0,0,0,0.2);
                        height: auto;
                        width: 100%;
                      }
        
                      .label-value-pair {
                        display: flex;
                        flex-direction: row,
                        align-items: flex-start;
                        gap: 5px;
                        margin-bottom: 8px;
                        flex-wrap: wrap;
                      }
        
                      .label {
                        font-weight: bold;
                        white-space: nowrap;
                      }
        
                      .value-box {
                        background-color:rgb(235, 235, 235);
                        padding: 6px 10px;
                        border-radius: 4px;
                        display: block;
                        word-wrap: break-word;
                        overflow-wrap: break-word;
                        flex-grow: 1;
                        min-width: 0;
                      }

                      .align-right {
                        text-align: right;
                        background-color:rgb(235, 235, 235);
                        padding: 6px 10px;
                        border-radius: 4px;
                        display: block;
                        word-wrap: break-word;
                        overflow-wrap: break-word;
                        flex-grow: 1;
                        min-width: 0;
                      }

                      .btn-container {
                      display: flex;
                      justify-content: center;
                      gap:20px;
                      margin-top:20px;
                      }
                    `}
                    </style>
                    </div>
    </div>
  );
};

export default DefectTypeCodes;
